// ==============================================
// ==================Import======================
// ==============================================

// ===================Dependancies================
import { useEffect } from 'react';

// ===================Leaflet================

import { useMap } from 'react-leaflet/hooks';
import useSize from '../useSize';

// ===================Actions================

function UseMap() {
  const mymap = useMap();
  const { width, height } = useSize();

  useEffect(() => {
    if (mymap) {
      if (height !== undefined && width !== undefined) {
        setTimeout(() => {
          mymap.invalidateSize();
        }, 100);
      }
    }
  }, [height, width, mymap]);

  return null;
}

export default UseMap;
